import { render } from "./GasPreset.vue?vue&type=template&id=f17cc67c"
import script from "./GasPreset.vue?vue&type=script&lang=js"
export * from "./GasPreset.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__